import { Navigate, Outlet, useLocation } from 'react-router-dom';

export default function GuestGuard() {
  const { pathname } = useLocation();
  let mode = '';
  try {
    mode = process.env.VITE_ELECTRON_MODE || '';
  } catch (error) {
    mode = '';
  }

  if (pathname === '/visitor-register' || pathname === '/visitor-information') {
    return <Outlet />;
  } else if (mode === 'kiosk') {
    return <Navigate to="/visitor-register" />;
  } else if (mode === 'information') {
    return <Navigate to="/visitor-information" />;
  } else {
    return <Outlet />;
  }
}
